export interface ReportBlock {
  top: number;
  bottom: number;
}

export function reportPageEnds(height: number, pageHeight: number, blocks: ReportBlock[]): number[] {
  if (pageHeight <= 0) throw new Error('Page height must be positive.');

  const fittingBlocks = blocks.filter(block => block.bottom - block.top <= pageHeight);
  const ends: number[] = [];
  let start = 0;
  while (start < height) {
    let end = Math.min(start + pageHeight, height);
    let crossing: ReportBlock | undefined;
    while ((crossing = fittingBlocks.find(block =>
      block.top > start && block.top < end && block.bottom > end))) {
      end = crossing.top;
    }
    ends.push(end);
    start = end;
  }
  return ends;
}